// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Font Sizes */
  --report-font-size-base: 10pt;
  --report-font-size-header-sm: 11pt;
  --report-font-size-header-lg: 12pt;
  --report-font-size-title-sm: 13pt;
  --report-font-size-title-lg: 15pt;

  /* Row Heights */
  --detail-row-height: 30px;
  --table-header-height: 34px;
  --activity-header-height: 30px;
  --core-header-height: 36px;
  --total-row-height: 36px;
  --grand-total-height: 48px;

  /* Colors */
  --report-header-blue: var(--uu-blue-topaz);
  --report-core-header: var(--uu-wasatch-sunrise);
  --report-core-header-alt: var(--uu-mountain-green);
  --report-core-cat-total: #6cc24a6e;
  --report-header-gray: var(--bp-gray5);
  --report-total-gray: var(--bp-light-gray2);
  --report-background-gray: var(--bp-light-gray4);
  --report-core-total: var(--uu-granite-peak);
  --report-grand-total: var(--uu-lake-powell);
}

.ReportTable-module_report_table_container_Far1G {
  border: 1px solid lightgray;
  background-color: #ffffff;
  background-clip: border-box;
  padding: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
}

.ReportTable-module_table_header_lpq0I {
  display: flex;
  align-items: center;
}

.ReportTable-module_table_header_lpq0I > * {
  margin-bottom: 0 !important;
}

.ReportTable-module_clickable_header_I4gCQ {
  color: var(--primary-bos-color);
  cursor: pointer;
}

.ReportTable-module_clickable_header_I4gCQ:hover {
  color: var(--primary-hover-color);
}

.ReportTable-module_report_input_XDlh9 {
  margin: 2px;
}

.ReportTable-module_export_button_AfJiF {
}

.ReportTable-module_report_table_Bx3JS {
  table-layout: fixed;
  width: 100%;
  height: 100%;
  max-height: 100%;
}

.ReportTable-module_report_table_Bx3JS tbody {
  /*border-bottom: 1px solid lightgray;*/
}

.ReportTable-module_report_table_Bx3JS th {
  background-color: white;
  text-align: left;
  vertical-align: middle;
  padding-left: 6px;
  padding-right: 6px;
  font-size: var(--report-font-size-header-lg);
  font-weight: 400;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
}

.ReportTable-module_report_table_Bx3JS th {
  height: var(--table-header-height);
  z-index: 2;
  position: sticky;
  top: 0;
}

.ReportTable-module_report_table_Bx3JS tr th:last-child,
.ReportTable-module_report_table_Bx3JS tr td:last-child {
  padding-right: 10px !important;
}

.ReportTable-module_report_table_Bx3JS tr th:first-child:not(.ReportTable-module_header_row_txmQ3),
.ReportTable-module_report_table_Bx3JS tr td:first-child:not(.ReportTable-module_header_row_txmQ3) {
  padding-left: 10px !important;
}

.ReportTable-module_money_header_OtQE3 {
  text-align: right !important;
}

.ReportTable-module_report_table_Bx3JS td {
  vertical-align: middle;
  padding-right: 6px;
  white-space: nowrap;
  overflow: hidden;
  /* text-overflow: ellipsis; */
}

.ReportTable-module_expand_all_button_WBULz {
  padding-left: 0;
  padding-right: 0;
}

.ReportTable-module_expand_button_Y_Uqn {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.ReportTable-module_header_row_txmQ3 {
  font-weight: 500;
  font-size: var(--report-font-size-header-sm);
  color: var(--text-color);
  border: none !important;
  position: sticky;
  top: 0;
  height: var(--activity-header-height);
  z-index: 2;
  padding-left: 0 !important;
}

.ReportTable-module_agg_header_wrapper_MdDhG span,
.ReportTable-module_header_row_txmQ3 span {
  color: currentColor;
}

.ReportTable-module_agg_header_wrapper_MdDhG span:hover,
.ReportTable-module_header_row_txmQ3 span:hover {
  color: var(--uu-red-rocks);
}

.ReportTable-module_header_wrapper_PjzoG {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
}

.ReportTable-module_agg_header_wrapper_MdDhG {
  justify-content: flex-end;
}

.ReportTable-module_core_header_D1ED9 {
  font-size: var(--report-font-size-header-lg);
  /* padding-top: 10px !important; */
  /* padding-bottom: 10px !important; */
  position: sticky;
  height: var(--core-header-height);
  top: calc(var(--table-header-height));
}

.ReportTable-module_core_header_orange_q1fZE {
  background-color: var(--report-core-header);
}

.ReportTable-module_core_header_blue_NDfpG {
  background-color: var(--report-core-header-alt);
}

.ReportTable-module_activity_header_utW1x {
  background-color: var(--report-header-blue);
  position: sticky;
  top: calc(var(--core-header-height) + var(--table-header-height));
}

.ReportTable-module_abr_header_KVwKc {
  background-color: var(--report-header-gray);
  position: sticky;
  top: calc(
    var(--core-header-height) + var(--table-header-height) +
      var(--activity-header-height)
  );
}

.ReportTable-module_abr_code_UeUZs {
  text-align: right;
}

.ReportTable-module_core_header_D1ED9 button,
.ReportTable-module_abr_header_KVwKc button {
  background-color: transparent !important;
  border: none !important;
}

.ReportTable-module_detail_cell_eSig_ {
  height: var(--detail-row-height);
  font-size: var(--report-font-size-base);
}

.ReportTable-module_agg_cell_VjELQ {
  background-color: var(--report-total-gray);
  border-top: 1px var(--muted-text) solid;
  height: var(--total-row-height);
  font-weight: 600;
  text-align: right;
}

.ReportTable-module_agg_cell_VjELQ:not(.ReportTable-module_money_cell_RKH5E) {
  font-size: var(--report-font-size-header-sm);
}

.ReportTable-module_money_cell_RKH5E {
  padding-left: 0 !important;
  white-space: pre !important;
  font-weight: 400;
}

.ReportTable-module_grand_total_Q3f7M {
  border-top: 1px black solid;
  height: var(--grand-total-height);
  font-size: var(--report-font-size-title-lg);
  font-weight: 500;
  background-color: var(--report-grand-total);
  color: white !important;
  text-align: right;
}

.ReportTable-module_grand_total_Q3f7M.ReportTable-module_money_cell_RKH5E {
  font-size: var(--report-font-size-header-lg);
}

.ReportTable-module_core_total_NH_HB {
  background-color: var(--report-core-total);
  color: white !important;
}

.ReportTable-module_core_category_total_RM4yz {
  background-color: var(--report-core-cat-total);
}

.ReportTable-module_gray_background_cell_mZ7iX {
  background-color: var(--report-background-gray);
}

.ReportTable-module_detail_cell_gray_t27nd {
}

.ReportTable-module_jump_to_menu_OYMx9 {
  max-height: 300px;
  overflow-y: auto;
}

.ReportTable-module_record_number_label_QuPIj {
  margin-left: auto;
  margin-right: 4px;
  margin-top: 2px;
  font-size: 9.6pt;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Reports/ReportTable.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;;EAEjC,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;EACxB,0BAA0B;;EAE1B,WAAW;EACX,0CAA0C;EAC1C,+CAA+C;EAC/C,kDAAkD;EAClD,kCAAkC;EAClC,qCAAqC;EACrC,0CAA0C;EAC1C,+CAA+C;EAC/C,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;AAEA;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,MAAM;AACR;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;EACN,qCAAqC;EACrC,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,4CAA4C;EAC5C,kCAAkC;EAClC,qCAAqC;EACrC,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EAEE,2CAA2C;AAC7C;;AAEA;EAEE,+CAA+C;AACjD;;AAEA;EAEE,2CAA2C;EAC3C,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EAEE,2CAA2C;EAC3C,gBAAgB;EAChB;;;GAGC;AACH;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2CAA2C;EAC3C,gBAAgB;EAChB,2CAA2C;EAC3C,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;AAGA;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[":root {\n  /* Font Sizes */\n  --report-font-size-base: 10pt;\n  --report-font-size-header-sm: 11pt;\n  --report-font-size-header-lg: 12pt;\n  --report-font-size-title-sm: 13pt;\n  --report-font-size-title-lg: 15pt;\n\n  /* Row Heights */\n  --detail-row-height: 30px;\n  --table-header-height: 34px;\n  --activity-header-height: 30px;\n  --core-header-height: 36px;\n  --total-row-height: 36px;\n  --grand-total-height: 48px;\n\n  /* Colors */\n  --report-header-blue: var(--uu-blue-topaz);\n  --report-core-header: var(--uu-wasatch-sunrise);\n  --report-core-header-alt: var(--uu-mountain-green);\n  --report-core-cat-total: #6cc24a6e;\n  --report-header-gray: var(--bp-gray5);\n  --report-total-gray: var(--bp-light-gray2);\n  --report-background-gray: var(--bp-light-gray4);\n  --report-core-total: var(--uu-granite-peak);\n  --report-grand-total: var(--uu-lake-powell);\n}\n\n.report_table_container {\n  border: 1px solid lightgray;\n  background-color: #ffffff;\n  background-clip: border-box;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n.table_header {\n  display: flex;\n  align-items: center;\n}\n\n.table_header > * {\n  margin-bottom: 0 !important;\n}\n\n.clickable_header {\n  color: var(--primary-bos-color);\n  cursor: pointer;\n}\n\n.clickable_header:hover {\n  color: var(--primary-hover-color);\n}\n\n.report_input {\n  margin: 2px;\n}\n\n.export_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n}\n\n.report_table {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n\n.report_table tbody {\n  /*border-bottom: 1px solid lightgray;*/\n}\n\n.report_table th {\n  background-color: white;\n  text-align: left;\n  vertical-align: middle;\n  padding-left: 6px;\n  padding-right: 6px;\n  font-size: var(--report-font-size-header-lg);\n  font-weight: 400;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: clip;\n}\n\n.report_table th {\n  height: var(--table-header-height);\n  z-index: 2;\n  position: sticky;\n  top: 0;\n}\n\n.report_table tr th:last-child,\n.report_table tr td:last-child {\n  padding-right: 10px !important;\n}\n\n.report_table tr th:first-child:not(.header_row),\n.report_table tr td:first-child:not(.header_row) {\n  padding-left: 10px !important;\n}\n\n.money_header {\n  text-align: right !important;\n}\n\n.report_table td {\n  vertical-align: middle;\n  padding-right: 6px;\n  white-space: nowrap;\n  overflow: hidden;\n  /* text-overflow: ellipsis; */\n}\n\n.expand_all_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.expand_button {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n\n.header_row {\n  font-weight: 500;\n  font-size: var(--report-font-size-header-sm);\n  color: var(--text-color);\n  border: none !important;\n  position: sticky;\n  top: 0;\n  height: var(--activity-header-height);\n  z-index: 2;\n  padding-left: 0 !important;\n}\n\n.agg_header_wrapper span,\n.header_row span {\n  color: currentColor;\n}\n\n.agg_header_wrapper span:hover,\n.header_row span:hover {\n  color: var(--uu-red-rocks);\n}\n\n.header_wrapper {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\n.agg_header_wrapper {\n  composes: header_wrapper;\n  justify-content: flex-end;\n}\n\n.core_header {\n  composes: header_row;\n  font-size: var(--report-font-size-header-lg);\n  /* padding-top: 10px !important; */\n  /* padding-bottom: 10px !important; */\n  position: sticky;\n  height: var(--core-header-height);\n  top: calc(var(--table-header-height));\n}\n\n.core_header_orange {\n  composes: core_header;\n  background-color: var(--report-core-header);\n}\n\n.core_header_blue {\n  composes: core_header;\n  background-color: var(--report-core-header-alt);\n}\n\n.activity_header {\n  composes: header_row;\n  background-color: var(--report-header-blue);\n  position: sticky;\n  top: calc(var(--core-header-height) + var(--table-header-height));\n}\n\n.abr_header {\n  composes: header_row;\n  background-color: var(--report-header-gray);\n  position: sticky;\n  top: calc(\n    var(--core-header-height) + var(--table-header-height) +\n      var(--activity-header-height)\n  );\n}\n\n.abr_code {\n  text-align: right;\n}\n\n.core_header button,\n.abr_header button {\n  background-color: transparent !important;\n  border: none !important;\n}\n\n.detail_cell {\n  height: var(--detail-row-height);\n  font-size: var(--report-font-size-base);\n}\n\n.agg_cell {\n  background-color: var(--report-total-gray);\n  border-top: 1px var(--muted-text) solid;\n  height: var(--total-row-height);\n  font-weight: 600;\n  text-align: right;\n}\n\n.agg_cell:not(.money_cell) {\n  font-size: var(--report-font-size-header-sm);\n}\n\n.money_cell {\n  composes: money_cell from 'Styles/styles.module.css';\n  padding-left: 0 !important;\n  white-space: pre !important;\n  font-weight: 400;\n}\n\n.grand_total {\n  border-top: 1px black solid;\n  height: var(--grand-total-height);\n  font-size: var(--report-font-size-title-lg);\n  font-weight: 500;\n  background-color: var(--report-grand-total);\n  color: white !important;\n  text-align: right;\n}\n\n.grand_total.money_cell {\n  font-size: var(--report-font-size-header-lg);\n}\n\n.core_total {\n  background-color: var(--report-core-total);\n  color: white !important;\n}\n\n.core_category_total {\n  background-color: var(--report-core-cat-total);\n}\n\n.gray_background_cell {\n  background-color: var(--report-background-gray);\n}\n\n.detail_cell_gray {\n  composes: detail_cell;\n  composes: gray_background_cell;\n}\n\n.jump_to_menu {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.record_number_label {\n  margin-left: auto;\n  margin-right: 4px;\n  margin-top: 2px;\n  font-size: 9.6pt;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"report_table_container": `ReportTable-module_report_table_container_Far1G`,
	"table_header": `ReportTable-module_table_header_lpq0I`,
	"clickable_header": `ReportTable-module_clickable_header_I4gCQ`,
	"report_input": `ReportTable-module_report_input_XDlh9`,
	"export_button": `ReportTable-module_export_button_AfJiF ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`,
	"report_table": `ReportTable-module_report_table_Bx3JS`,
	"header_row": `ReportTable-module_header_row_txmQ3`,
	"money_header": `ReportTable-module_money_header_OtQE3`,
	"expand_all_button": `ReportTable-module_expand_all_button_WBULz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`,
	"expand_button": `ReportTable-module_expand_button_Y_Uqn`,
	"agg_header_wrapper": `ReportTable-module_agg_header_wrapper_MdDhG ReportTable-module_header_wrapper_PjzoG`,
	"header_wrapper": `ReportTable-module_header_wrapper_PjzoG`,
	"core_header": `ReportTable-module_core_header_D1ED9 ReportTable-module_header_row_txmQ3`,
	"core_header_orange": `ReportTable-module_core_header_orange_q1fZE ReportTable-module_core_header_D1ED9 ReportTable-module_header_row_txmQ3`,
	"core_header_blue": `ReportTable-module_core_header_blue_NDfpG ReportTable-module_core_header_D1ED9 ReportTable-module_header_row_txmQ3`,
	"activity_header": `ReportTable-module_activity_header_utW1x ReportTable-module_header_row_txmQ3`,
	"abr_header": `ReportTable-module_abr_header_KVwKc ReportTable-module_header_row_txmQ3`,
	"abr_code": `ReportTable-module_abr_code_UeUZs`,
	"detail_cell": `ReportTable-module_detail_cell_eSig_`,
	"agg_cell": `ReportTable-module_agg_cell_VjELQ`,
	"money_cell": `ReportTable-module_money_cell_RKH5E ${___CSS_LOADER_ICSS_IMPORT_0___.locals["money_cell"]}`,
	"grand_total": `ReportTable-module_grand_total_Q3f7M`,
	"core_total": `ReportTable-module_core_total_NH_HB`,
	"core_category_total": `ReportTable-module_core_category_total_RM4yz`,
	"gray_background_cell": `ReportTable-module_gray_background_cell_mZ7iX`,
	"detail_cell_gray": `ReportTable-module_detail_cell_gray_t27nd ReportTable-module_detail_cell_eSig_ ReportTable-module_gray_background_cell_mZ7iX`,
	"jump_to_menu": `ReportTable-module_jump_to_menu_OYMx9`,
	"record_number_label": `ReportTable-module_record_number_label_QuPIj`
};
export default ___CSS_LOADER_EXPORT___;
